const config = require('../../config/index')
const axios = require('axios')
const Singleton = require('../../Singleton').default

// var SerisesData = {
//   seriesesFiles: [],
//   state: {},
// }

// var getData = (seriesesFiles, state) => {
//   if (seriesesFiles.length > 0 &&
//     seriesesFiles.length == state.seriesesInState.length)
//   {
//     return state.seriesesInState
//   }
//   return []
// }
var getSerieses = (seriesesFiles, state) => {
  // SerisesData.seriesesFiles = seriesesFiles
  // SerisesData.state = state

  // console.log('getSerieses [date]:',
  //   this.default.id,
  //   this.default.date)
  let _this = this

  return new Promise((resolve) => {
    // 原本要抓取的 series 檔案集合搬到 state 了
    let seriesArray = []
    _this = _this.default

    let getDataAsync = async (filename) => {
      let uri = `${config.SeriesData}${filename}`

      try {
        //console.log('[getSerieses.js]', 'getDataAsync', filename, status.isFetching)
        const { data } = await axios.get(uri)

        return data
      }
      catch (ex) {
        console.log('[getSerieses.js]', 'getDataAsync', filename, ex)

        throw(ex)
      }

    }

    //console.log('>>> getSerieses', 'status.isFetching', _this.isFetching)
    if (_this.isFetching == true) {
      let waitFetching = (timeout) => {
        if (_this.isFetching == false && _this.hasData == true) {
          return resolve(_this.getData(seriesesFiles, state))
        }

        setTimeout(function() { waitFetching(timeout); }, timeout)
      }

      waitFetching(100)
      return
    }

    //console.log('>>> getSerieses', 'status.hasData', _this.hasData, 'status.dataExpire', _this.dataExpire)
    if (_this.hasData == true && _this.dataExpire == false) {
      var data = _this.getData(seriesesFiles, state)
      if (data.length == seriesesFiles.length) {
        return resolve(data)
      }
    }

    _this.isFetching = true

    seriesesFiles.forEach(async (seriesFileName) => {
      let data = await getDataAsync(seriesFileName)
      // console.log('[getSerieses.js]',
      //   '_getSerieses()',
      //   'forEach',
      //   'data',
      //   data)

      seriesArray.push(data)
    })

    let wait = (timeout, callback) => {
      // console.log('### getSerieses.js',
      //     'wait',
      //     'seriesArray', seriesArray)

      if (seriesArray.length == seriesesFiles.length) {
        // console.log('### getSerieses.js',
        //   'seriesArray', seriesArray)

        _this.setData(seriesArray)

        // console.log('### getSerieses.js',
        //   '#87 seriesArray',
        //   'getData',
        //   _this.getData(seriesesFiles, state))

        _this.isFetching = false
        //_this.hasData = true
        _this.hasData = (seriesArray.length == seriesesFiles.length)

        if (callback) {
          setTimeout(function() { callback(seriesArray); })
        }

        resolve(seriesArray)
        return
      }

      setTimeout(function() { wait(timeout, callback); }, timeout)
    }

    wait(100)
  })
}

var SeriesesFetchObject = new Singleton([
  {
    "name": "getSerieses",
    "fn": getSerieses
  },
  // {
  //   "name": "getData",
  //   "fn": getData
  // }
])

//SeriesesFetchObject.getSerieses = getSerieses

// let _getSerieses = () => {
//   // return new Promise((resolve) => {
//   //   let _serieses = [
//   //       // require('@/series-data/_state-series1.json'),
//   //       // require('@/series-data/_state-series2.json'),
//   //       // require('@/series-data/_state-series3.json'),
//   //       // require('@/series-data/_state-series4.json'),
//   //       // require('@/series-data/_state-series5.json'),
//   //       // require('@/series-data/_state-series6.json'),
//   //       //require('@/series-data/_state-series-w02.json'),

//   //       // axios version
//   //       "_state-series1.json",
//   //       "_state-series2.json",
//   //       "_state-series3.json",
//   //       "_state-series4.json",
//   //       "_state-series5.json",
//   //       "_state-series6.json",

//   //   ]

//   //   let seriesArray = []
//   //   _serieses.forEach(async (seriesFileName) => {
//   //     let data = await getDataAsync(seriesFileName)
//   //     //console.log('[getSerieses.js]', '_getSerieses()', 'forEach', 'data', data)

//   //     seriesArray.push(data)
//   //   })

//   //   //console.log('[getSerieses.js]', '_getSerieses()', 'seriesArray', seriesArray)
//   //   //while (seriesArray.length < _serieses.length) {}

//   //   //console.log('[getSerieses.js]', '_getSerieses()', 'seriesArray', seriesArray)
//   //   let wait = (timeout, callback) => {
//   //     setTimeout(function() {
//   //       if (seriesArray.length == _serieses.length) {
//   //         //console.log('[getSerieses.js]', '_getSerieses()', 'seriesArray', seriesArray, '_serieses', _serieses)
//   //         if (callback) {
//   //           callback(seriesArray)
//   //         }
//   //         resolve(seriesArray)
//   //         return
//   //       }

//   //       wait(timeout, callback)
//   //     }, timeout)
//   //   }

//   //   wait(100)

//   //   //return _serieses
//   //   //return seriesArray
//   //   //resolve(seriesArray)
//   // })
// }

// let getDataAsync = async (filename) => {
//   let uri = `${config.SeriesData}${filename}`

//   try {
//     const { data } = await axios.get(uri)

//     return data
//   }
//   catch (ex) {
//     console.log('[getSerieses.js]', 'getDataAsync', filename, ex)

//     throw(ex)
//   }

// }

// export default _getSerieses
export default SeriesesFetchObject



// WEBPACK FOOTER //
// ./src/vuex/actions/getSerieses.js